<template>
  <div class="company_basic clearfix">
    <div class="info_container clearfix">
      <slot name="info"></slot>
    </div>
    <!-- Key information -->
    <div class="key_information">
      <title-temp title="Key information"></title-temp>
      <table-form :columnData="keyColumnData" :tableData="keyTableData" cls="double"></table-form>
    </div>

    <!-- Company overview -->
    <div class="company_overview">
      <title-temp title="Company overview"></title-temp>
      <!-- 数据中有 br 换行符 -->
      <p class="overview" v-html="overview"></p>
    </div>

    <!-- Industry & activities -->
    <div class="industry_activities">
      <title-temp title="Industry & activities"></title-temp>
      <table-form :columnData="industryColumnData" :tableData="industryTableData"></table-form>
    </div>

    <!-- directors & managers -->
    <div class="idirectors_managers">
      <title-temp title="Directors & managers"></title-temp>
      <table-form :columnData="idirectorsColumnData" :tableData="idirectorsTableData"></table-form>
    </div>

    <!-- Auditors -->
    <div class="auditors">
      <title-temp title="Auditors"></title-temp>
      <table-form :columnData="auditorsColumnData" :tableData="auditorsTableData"></table-form>
    </div>

    <!-- Legal events 暂时删除-->
    <!-- <div class="legal_events">
      <title-temp title="Legal events"></title-temp>
      <table-form :columnData="legalColumnData" :tableData="legalTableData"></table-form>
    </div>-->
  </div>
</template>

<script>
import TitleTemp from "common/components/Title";
import TableForm from "common/components/tableForm";
import { getBasic } from "common/js/http/v2Api";
import {
  keyColumnData,
  industryColumnData,
  idirectorsColumnData,
  auditorsColumnData,
  legalColumnData
} from "conf/Basic";

import { mapMutations } from "vuex";

export default {
  components: {
    TitleTemp,
    TableForm
  },

  data() {
    return {
      id: this.$route.query.id,
      code: this.$route.query.code,
      keyColumnData,
      keyTableData: {},

      overview: "",

      industryColumnData,
      industryTableData: {},

      idirectorsColumnData,
      idirectorsTableData: {},

      auditorsColumnData,
      auditorsTableData: {},

      legalColumnData,
      legalTableData: {}
    };
  },

  created() {
    this.getBasicData();
  },

  methods: {
    async getBasicData() {
      const { result } = await getBasic(this.id, this.code);
      this.keyTableData = result["Key information"];
      //增加单位
      if (this.keyTableData && this.keyTableData.registered_capital) {
        let unit;
        if (result.currency_unit) {
          unit = result.currency_unit == "unit" ? "" : result.currency_unit;
        } else unit = "";
        let name = result.currency_name || "";
        this.keyTableData.registered_capital += " " + unit + " " + name;
      }
      this.overview = result["Company Overview"].company_overview;
      this.industryTableData = result["Industry & Activities"];
      this.idirectorsTableData = result["Directors & Managers"];
      this.auditorsTableData = result["Auditors"];

      this.setDataSource(result.dataSource);
    },

    ...mapMutations(["setDataSource"])
  },

  watch: {}
};
</script>

<style scoped>
.company_basic {
  position: relative;
}

.overview {
  padding: 15px;
  border: 1px solid #f3f4f5;
  font-size: 14px;
  color: #4e5671;
  line-height: 20px;
  height: 150px;
  overflow-y: auto;
}
</style>